import { Component, DoCheck, forwardRef, Input, OnDestroy, OnInit } from "@angular/core";
import { AbstractControl, ControlValueAccessor, FormControl, FormGroup, NG_VALIDATORS, NG_VALUE_ACCESSOR, ValidationErrors, Validator, Validators } from "@angular/forms";
import { Subscription } from "rxjs";
import { MAT_DATE_LOCALE } from "@angular/material/core";
import { NGX_MAT_DATE_FORMATS, NgxMatDateAdapter, NgxMatDateFormats } from "@angular-material-components/datetime-picker";
import { NGX_MAT_MOMENT_DATE_ADAPTER_OPTIONS, NgxMatMomentAdapter } from "@angular-material-components/moment-adapter";
import { Moment } from "moment";
import { MyErrorStateMatcher } from "../../error/error-matcher";
import * as moment from "moment";
import { LanguageLocalDatepicker } from "src/app/core/constants/language-locale-datepicker";
import { SendInfoComponentService } from "src/app/core/services/local/send-info.component.service";

export function getFormDateTime(withValidation: boolean): FormGroup {
    let validations = withValidation ? [Validators.required] : [];
    return new FormGroup({
      dateTime: new FormControl('', validations)
    });
}
export function getObjectDateTime(timeNow?: boolean): any {
    if (timeNow) {
        return { dateTime: moment() };
    } else {
        return { dateTime: '' };
    }
}
const CUSTOM_DATE_FORMATS: NgxMatDateFormats = {
    parse: {
        dateInput: "DD/MM/yyyy hh:mm"
    },
    display: {
        dateInput: "DD/MM/yyyy hh:mm A",
        monthYearLabel: "MMM YYYY",
        dateA11yLabel: "LL",
        monthYearA11yLabel: "MMMM YYYY"
    }
};
@Component({
    selector: 'control-date-time',
    templateUrl: './date-time.component.html',
    styleUrls: ['./date-time.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => DateTimeComponent),
            multi: true,
        },
        {
            provide: NG_VALIDATORS,
            useExisting: forwardRef(() => DateTimeComponent),
            multi: true,
        },
        {
            provide: NgxMatDateAdapter,
            useClass: NgxMatMomentAdapter,
            deps: [MAT_DATE_LOCALE, NGX_MAT_MOMENT_DATE_ADAPTER_OPTIONS]
        },
        { provide: NGX_MAT_DATE_FORMATS, useValue: CUSTOM_DATE_FORMATS }
    ]
})
export class DateTimeComponent implements OnInit, DoCheck, OnDestroy, ControlValueAccessor, Validator{
    @Input() isEdit: boolean;
    @Input() placeholder: string = "Seleccione una fecha y hora";
    @Input() required: boolean = false;
    @Input() nameClass = "";
    @Input() minDate?: Date = null;
    @Input() maxDate?: Date = null;
    @Input() is12hr?: boolean = false;

    form!: FormGroup ;    
    matcher = new MyErrorStateMatcher();
    disabled: boolean = false;
    update: boolean;
    cveLanguage: string;

    private sub?: Subscription;
    onTouched?: () => { };

    constructor(private dateAdapter: NgxMatDateAdapter<Moment>, private sendInfo: SendInfoComponentService){
      moment.locale([LanguageLocalDatepicker.es, LanguageLocalDatepicker.en, LanguageLocalDatepicker.pt]);
    }

    ngOnInit(): void {
        this.form = getFormDateTime(true);
        if (this.isEdit) {
            this.form.disable();
            this.nameClass = "disabled";
        } else {
            this.form.enable();
            this.nameClass = "";
        }
        this.onListenTranslate();
    }
    ngDoCheck() {
        if (this.update) {          
            this.update = false;
            this.dateAdapter.setLocale(LanguageLocalDatepicker[this.cveLanguage]);
            moment.locale(LanguageLocalDatepicker[this.cveLanguage]);
        }
    }
    
    validate(control: AbstractControl<any, any>): ValidationErrors | null {
        return this.form.get("dateTime").errors;
    }
    
    writeValue(obj: any): void {
        if (!obj) {
            obj = getObjectDateTime();
        }
        obj && this.form.setValue(obj, { emitEvent: false });
    }
    registerOnChange(fn: any): void {
        this.sub = this.form.valueChanges.subscribe(fn);
    }
    registerOnTouched(fn: any): void {
        this.onTouched = fn;
    }
    setDisabledState?(isDisabled: boolean): void {
        if (isDisabled) {
            this.form.disable();
            this.nameClass = 'disabled';
        } else {
            this.form.enable();
            this.nameClass = '';
        }
        this.disabled = isDisabled;
    }
    
    ngOnDestroy(): void {
        this.sub?.unsubscribe();
    }

    onListenTranslate(){
      this.sendInfo.sendObjectAction.subscribe(data => {
          this.cveLanguage = data.value;
          if (data.isExecuted && data.key === "traduction") {
            this.update = true;
          }
      });
  }
    
}